'use strict';

var _slicedToArray = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _asyncIterator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

var _get = require('just-safe-get');

var debug = require('debug');

var Big = require('bignumber.js');

var errcode = require('err-code');

var migrator = require('ipfs-repo-migrations');

var bytes = require('bytes');

var pathJoin = require('ipfs-utils/src/path-join');

var constants = require('./constants');

var backends = require('./backends');

var version = require('./version');

var config = require('./config');

var spec = require('./spec');

var apiAddr = require('./api-addr');

var blockstore = require('./blockstore');

var defaultOptions = require('./default-options');

var defaultDatastore = require('./default-datastore');

var ERRORS = require('./errors');

var log = debug('repo');
var noLimit = Number.MAX_SAFE_INTEGER;
var AUTO_MIGRATE_CONFIG_KEY = 'repoAutoMigrate';
var lockers = {
  memory: require('./lock-memory'),
  fs: require('./lock')
};
/**
 * IpfsRepo implements all required functionality to read and write to an ipfs repo.
 *
 */

var IpfsRepo = /*#__PURE__*/function () {
  /**
   * @param {string} repoPath - path where the repo is stored
   * @param {object} options - Configuration
   */
  function IpfsRepo(repoPath, options) {
    _classCallCheck(this, IpfsRepo);

    if (typeof repoPath !== 'string') {
      throw new Error('missing repoPath');
    }

    this.options = buildOptions(options);
    this.closed = true;
    this.path = repoPath;
    this._locker = this._getLocker();
    this.root = backends.create('root', this.path, this.options);
    this.version = version(this.root);
    this.config = config(this.root);
    this.spec = spec(this.root);
    this.apiAddr = apiAddr(this.root);
  }
  /**
   * Initialize a new repo.
   *
   * @param {Object} config - config to write into `config`.
   * @returns {Promise<void>}
   */


  _createClass(IpfsRepo, [{
    key: "init",
    value: function () {
      var _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(config) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                log('initializing at: %s', this.path);
                _context.next = 3;
                return this._openRoot();

              case 3:
                _context.next = 5;
                return this.config.set(buildConfig(config));

              case 5:
                _context.next = 7;
                return this.spec.set(buildDatastoreSpec(config));

              case 7:
                _context.next = 9;
                return this.version.set(constants.repoVersion);

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function init(_x) {
        return _init.apply(this, arguments);
      }

      return init;
    }()
    /**
     * Check if the repo is already initialized.
     * @returns {Promise<Boolean>}
     */

  }, {
    key: "isInitialized",
    value: function () {
      var _isInitialized = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (this.closed) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return", true);

              case 2:
                _context2.prev = 2;
                _context2.next = 5;
                return this._openRoot();

              case 5:
                _context2.next = 7;
                return this._checkInitialized();

              case 7:
                _context2.next = 9;
                return this.root.close();

              case 9:
                return _context2.abrupt("return", true);

              case 12:
                _context2.prev = 12;
                _context2.t0 = _context2["catch"](2);
                return _context2.abrupt("return", false);

              case 15:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[2, 12]]);
      }));

      function isInitialized() {
        return _isInitialized.apply(this, arguments);
      }

      return isInitialized;
    }()
    /**
     * Open the repo. If the repo is already open an error will be thrown.
     * If the repo is not initialized it will throw an error.
     *
     * @returns {Promise<void>}
     */

  }, {
    key: "open",
    value: function () {
      var _open = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var blocksBaseStore, isCompatible;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (this.closed) {
                  _context3.next = 2;
                  break;
                }

                throw errcode(new Error('repo is already open'), ERRORS.ERR_REPO_ALREADY_OPEN);

              case 2:
                log('opening at: %s', this.path); // check if the repo is already initialized

                _context3.prev = 3;
                _context3.next = 6;
                return this._openRoot();

              case 6:
                _context3.next = 8;
                return this._checkInitialized();

              case 8:
                _context3.next = 10;
                return this._openLock(this.path);

              case 10:
                this.lockfile = _context3.sent;
                log('acquired repo.lock');
                log('creating datastore');
                this.datastore = backends.create('datastore', pathJoin(this.path, 'datastore'), this.options);
                _context3.next = 16;
                return this.datastore.open();

              case 16:
                log('creating blocks');
                blocksBaseStore = backends.create('blocks', pathJoin(this.path, 'blocks'), this.options);
                _context3.next = 20;
                return blocksBaseStore.open();

              case 20:
                _context3.next = 22;
                return blockstore(blocksBaseStore, this.options.storageBackendOptions.blocks);

              case 22:
                this.blocks = _context3.sent;
                log('creating keystore');
                this.keys = backends.create('keys', pathJoin(this.path, 'keys'), this.options);
                _context3.next = 27;
                return this.keys.open();

              case 27:
                _context3.next = 29;
                return this.version.check(constants.repoVersion);

              case 29:
                isCompatible = _context3.sent;

                if (isCompatible) {
                  _context3.next = 39;
                  break;
                }

                _context3.next = 33;
                return this._isAutoMigrationEnabled();

              case 33:
                if (!_context3.sent) {
                  _context3.next = 38;
                  break;
                }

                _context3.next = 36;
                return this._migrate(constants.repoVersion);

              case 36:
                _context3.next = 39;
                break;

              case 38:
                throw new ERRORS.InvalidRepoVersionError('Incompatible repo versions. Automatic migrations disabled. Please migrate the repo manually.');

              case 39:
                this.closed = false;
                log('all opened');
                _context3.next = 56;
                break;

              case 43:
                _context3.prev = 43;
                _context3.t0 = _context3["catch"](3);

                if (!this.lockfile) {
                  _context3.next = 55;
                  break;
                }

                _context3.prev = 46;
                _context3.next = 49;
                return this._closeLock();

              case 49:
                this.lockfile = null;
                _context3.next = 55;
                break;

              case 52:
                _context3.prev = 52;
                _context3.t1 = _context3["catch"](46);
                log('error removing lock', _context3.t1);

              case 55:
                throw _context3.t0;

              case 56:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[3, 43], [46, 52]]);
      }));

      function open() {
        return _open.apply(this, arguments);
      }

      return open;
    }()
    /**
     * Returns the repo locker to be used. Null will be returned if no locker is requested
     *
     * @private
     * @returns {Locker}
     */

  }, {
    key: "_getLocker",
    value: function _getLocker() {
      if (typeof this.options.lock === 'string') {
        if (!lockers[this.options.lock]) {
          throw new Error('Unknown lock type: ' + this.options.lock);
        }

        return lockers[this.options.lock];
      }

      if (!this.options.lock) {
        throw new Error('No lock provided');
      }

      return this.options.lock;
    }
    /**
     * Opens the root backend, catching and ignoring an 'Already open' error
     * @returns {Promise}
     */

  }, {
    key: "_openRoot",
    value: function () {
      var _openRoot2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return this.root.open();

              case 3:
                _context4.next = 9;
                break;

              case 5:
                _context4.prev = 5;
                _context4.t0 = _context4["catch"](0);

                if (!(_context4.t0.message !== 'Already open')) {
                  _context4.next = 9;
                  break;
                }

                throw _context4.t0;

              case 9:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[0, 5]]);
      }));

      function _openRoot() {
        return _openRoot2.apply(this, arguments);
      }

      return _openRoot;
    }()
    /**
     * Creates a lock on the repo if a locker is specified. The lockfile object will
     * be returned in the callback if one has been created.
     *
     * @param {string} path
     * @returns {Promise<lockfile>}
     */

  }, {
    key: "_openLock",
    value: function () {
      var _openLock2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(path) {
        var lockfile;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this._locker.lock(path);

              case 2:
                lockfile = _context5.sent;

                if (!(typeof lockfile.close !== 'function')) {
                  _context5.next = 5;
                  break;
                }

                throw errcode(new Error('Locks must have a close method'), 'ERR_NO_CLOSE_FUNCTION');

              case 5:
                return _context5.abrupt("return", lockfile);

              case 6:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function _openLock(_x2) {
        return _openLock2.apply(this, arguments);
      }

      return _openLock;
    }()
    /**
     * Closes the lock on the repo
     *
     * @returns {Promise<void>}
     */

  }, {
    key: "_closeLock",
    value: function _closeLock() {
      return this.lockfile.close();
    }
    /**
     * Check if the repo is already initialized.
     * @private
     * @returns {Promise}
     */

  }, {
    key: "_checkInitialized",
    value: function () {
      var _checkInitialized2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var config, _yield$Promise$all, _yield$Promise$all2;

        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                log('init check');
                _context6.prev = 1;
                _context6.next = 4;
                return Promise.all([this.config.exists(), this.spec.exists(), this.version.exists()]);

              case 4:
                _yield$Promise$all = _context6.sent;
                _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 1);
                config = _yield$Promise$all2[0];
                _context6.next = 14;
                break;

              case 9:
                _context6.prev = 9;
                _context6.t0 = _context6["catch"](1);

                if (!(_context6.t0.code === 'ERR_NOT_FOUND')) {
                  _context6.next = 13;
                  break;
                }

                throw errcode(new Error('repo is not initialized yet'), ERRORS.ERR_REPO_NOT_INITIALIZED, {
                  path: this.path
                });

              case 13:
                throw _context6.t0;

              case 14:
                if (config) {
                  _context6.next = 16;
                  break;
                }

                throw errcode(new Error('repo is not initialized yet'), ERRORS.ERR_REPO_NOT_INITIALIZED, {
                  path: this.path
                });

              case 16:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[1, 9]]);
      }));

      function _checkInitialized() {
        return _checkInitialized2.apply(this, arguments);
      }

      return _checkInitialized;
    }()
    /**
     * Close the repo and cleanup.
     *
     * @returns {Promise<void>}
     */

  }, {
    key: "close",
    value: function () {
      var _close = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (!this.closed) {
                  _context7.next = 2;
                  break;
                }

                throw errcode(new Error('repo is already closed'), ERRORS.ERR_REPO_ALREADY_CLOSED);

              case 2:
                log('closing at: %s', this.path);
                _context7.prev = 3;
                _context7.next = 6;
                return this.apiAddr.delete();

              case 6:
                _context7.next = 12;
                break;

              case 8:
                _context7.prev = 8;
                _context7.t0 = _context7["catch"](3);

                if (!(_context7.t0.code !== ERRORS.ERR_REPO_NOT_INITIALIZED && !_context7.t0.message.startsWith('ENOENT'))) {
                  _context7.next = 12;
                  break;
                }

                throw _context7.t0;

              case 12:
                _context7.next = 14;
                return Promise.all([this.root, this.blocks, this.keys, this.datastore].map(function (store) {
                  return store.close();
                }));

              case 14:
                log('unlocking');
                this.closed = true;
                _context7.next = 18;
                return this._closeLock();

              case 18:
                this.lockfile = null;

              case 19:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this, [[3, 8]]);
      }));

      function close() {
        return _close.apply(this, arguments);
      }

      return close;
    }()
    /**
     * Check if a repo exists.
     *
     * @returns {Promise<bool>}
     */

  }, {
    key: "exists",
    value: function () {
      var _exists = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                return _context8.abrupt("return", this.version.exists());

              case 1:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function exists() {
        return _exists.apply(this, arguments);
      }

      return exists;
    }()
    /**
     * Get repo status.
     *
     * @returns {Object}
     */

  }, {
    key: "stat",
    value: function () {
      var _stat = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
        var _yield$Promise$all3, _yield$Promise$all4, storageMax, blocks, version, datastore, keys, size;

        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return Promise.all([this._storageMaxStat(), this._blockStat(), this.version.get(), getSize(this.datastore), getSize(this.keys)]);

              case 2:
                _yield$Promise$all3 = _context9.sent;
                _yield$Promise$all4 = _slicedToArray(_yield$Promise$all3, 5);
                storageMax = _yield$Promise$all4[0];
                blocks = _yield$Promise$all4[1];
                version = _yield$Promise$all4[2];
                datastore = _yield$Promise$all4[3];
                keys = _yield$Promise$all4[4];
                size = blocks.size.plus(datastore).plus(keys);
                return _context9.abrupt("return", {
                  repoPath: this.path,
                  storageMax: storageMax,
                  version: version,
                  numObjects: blocks.count,
                  repoSize: size
                });

              case 11:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function stat() {
        return _stat.apply(this, arguments);
      }

      return stat;
    }()
  }, {
    key: "_isAutoMigrationEnabled",
    value: function () {
      var _isAutoMigrationEnabled2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
        var autoMigrateConfig;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                if (!(this.options.autoMigrate !== undefined)) {
                  _context10.next = 2;
                  break;
                }

                return _context10.abrupt("return", this.options.autoMigrate);

              case 2:
                _context10.prev = 2;
                _context10.next = 5;
                return this.config.get(AUTO_MIGRATE_CONFIG_KEY);

              case 5:
                autoMigrateConfig = _context10.sent;
                _context10.next = 15;
                break;

              case 8:
                _context10.prev = 8;
                _context10.t0 = _context10["catch"](2);

                if (!(_context10.t0.code === ERRORS.NotFoundError.code)) {
                  _context10.next = 14;
                  break;
                }

                autoMigrateConfig = true; // Config's default value is True

                _context10.next = 15;
                break;

              case 14:
                throw _context10.t0;

              case 15:
                return _context10.abrupt("return", autoMigrateConfig);

              case 16:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this, [[2, 8]]);
      }));

      function _isAutoMigrationEnabled() {
        return _isAutoMigrationEnabled2.apply(this, arguments);
      }

      return _isAutoMigrationEnabled;
    }()
  }, {
    key: "_migrate",
    value: function () {
      var _migrate2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(toVersion) {
        var currentRepoVersion;
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.next = 2;
                return this.version.get();

              case 2:
                currentRepoVersion = _context11.sent;

                if (!(currentRepoVersion > toVersion)) {
                  _context11.next = 8;
                  break;
                }

                log('reverting to version ' + toVersion);
                return _context11.abrupt("return", migrator.revert(this.path, toVersion, {
                  ignoreLock: true,
                  repoOptions: this.options
                }));

              case 8:
                log('migrating to version ' + toVersion);
                return _context11.abrupt("return", migrator.migrate(this.path, toVersion, {
                  ignoreLock: true,
                  repoOptions: this.options
                }));

              case 10:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function _migrate(_x3) {
        return _migrate2.apply(this, arguments);
      }

      return _migrate;
    }()
  }, {
    key: "_storageMaxStat",
    value: function () {
      var _storageMaxStat2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12() {
        var max;
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.prev = 0;
                _context12.next = 3;
                return this.config.get('Datastore.StorageMax');

              case 3:
                max = _context12.sent;
                return _context12.abrupt("return", new Big(bytes(max)));

              case 7:
                _context12.prev = 7;
                _context12.t0 = _context12["catch"](0);
                return _context12.abrupt("return", new Big(noLimit));

              case 10:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this, [[0, 7]]);
      }));

      function _storageMaxStat() {
        return _storageMaxStat2.apply(this, arguments);
      }

      return _storageMaxStat;
    }()
  }, {
    key: "_blockStat",
    value: function () {
      var _blockStat2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13() {
        var count, size, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, block;

        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                count = new Big(0);
                size = new Big(0);
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _context13.prev = 4;
                _iterator = _asyncIterator(this.blocks.query({}));

              case 6:
                _context13.next = 8;
                return _iterator.next();

              case 8:
                _step = _context13.sent;
                _iteratorNormalCompletion = _step.done;
                _context13.next = 12;
                return _step.value;

              case 12:
                _value = _context13.sent;

                if (_iteratorNormalCompletion) {
                  _context13.next = 20;
                  break;
                }

                block = _value;
                count = count.plus(1);
                size = size.plus(block.value.byteLength).plus(block.key._buf.byteLength);

              case 17:
                _iteratorNormalCompletion = true;
                _context13.next = 6;
                break;

              case 20:
                _context13.next = 26;
                break;

              case 22:
                _context13.prev = 22;
                _context13.t0 = _context13["catch"](4);
                _didIteratorError = true;
                _iteratorError = _context13.t0;

              case 26:
                _context13.prev = 26;
                _context13.prev = 27;

                if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
                  _context13.next = 31;
                  break;
                }

                _context13.next = 31;
                return _iterator.return();

              case 31:
                _context13.prev = 31;

                if (!_didIteratorError) {
                  _context13.next = 34;
                  break;
                }

                throw _iteratorError;

              case 34:
                return _context13.finish(31);

              case 35:
                return _context13.finish(26);

              case 36:
                return _context13.abrupt("return", {
                  count: count,
                  size: size
                });

              case 37:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this, [[4, 22, 26, 36], [27,, 31, 35]]);
      }));

      function _blockStat() {
        return _blockStat2.apply(this, arguments);
      }

      return _blockStat;
    }()
  }]);

  return IpfsRepo;
}();

function getSize(_x4) {
  return _getSize.apply(this, arguments);
}

function _getSize() {
  _getSize = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(queryFn) {
    var sum, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, _value2, block;

    return _regeneratorRuntime.wrap(function _callee14$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
            sum = new Big(0);
            _iteratorNormalCompletion2 = true;
            _didIteratorError2 = false;
            _context14.prev = 3;
            _iterator2 = _asyncIterator(queryFn.query({}));

          case 5:
            _context14.next = 7;
            return _iterator2.next();

          case 7:
            _step2 = _context14.sent;
            _iteratorNormalCompletion2 = _step2.done;
            _context14.next = 11;
            return _step2.value;

          case 11:
            _value2 = _context14.sent;

            if (_iteratorNormalCompletion2) {
              _context14.next = 18;
              break;
            }

            block = _value2;
            sum.plus(block.value.byteLength).plus(block.key._buf.byteLength);

          case 15:
            _iteratorNormalCompletion2 = true;
            _context14.next = 5;
            break;

          case 18:
            _context14.next = 24;
            break;

          case 20:
            _context14.prev = 20;
            _context14.t0 = _context14["catch"](3);
            _didIteratorError2 = true;
            _iteratorError2 = _context14.t0;

          case 24:
            _context14.prev = 24;
            _context14.prev = 25;

            if (!(!_iteratorNormalCompletion2 && _iterator2.return != null)) {
              _context14.next = 29;
              break;
            }

            _context14.next = 29;
            return _iterator2.return();

          case 29:
            _context14.prev = 29;

            if (!_didIteratorError2) {
              _context14.next = 32;
              break;
            }

            throw _iteratorError2;

          case 32:
            return _context14.finish(29);

          case 33:
            return _context14.finish(24);

          case 34:
            return _context14.abrupt("return", sum);

          case 35:
          case "end":
            return _context14.stop();
        }
      }
    }, _callee14, null, [[3, 20, 24, 34], [25,, 29, 33]]);
  }));
  return _getSize.apply(this, arguments);
}

module.exports = IpfsRepo;
module.exports.utils = {
  blockstore: require('./blockstore-utils')
};
module.exports.repoVersion = constants.repoVersion;
module.exports.errors = ERRORS;

function buildOptions(_options) {
  var options = Object.assign({}, defaultOptions, _options);
  options.storageBackends = Object.assign({}, defaultOptions.storageBackends, options.storageBackends);
  options.storageBackendOptions = Object.assign({}, defaultOptions.storageBackendOptions, options.storageBackendOptions);
  return options;
} // TODO this should come from js-ipfs instead


function buildConfig(_config) {
  _config.datastore = Object.assign({}, defaultDatastore, _get(_config, 'datastore', {}));
  return _config;
}

function buildDatastoreSpec(_config) {
  var spec = Object.assign({}, defaultDatastore.Spec, _get(_config, 'datastore.Spec', {}));
  return {
    type: spec.type,
    mounts: spec.mounts.map(function (mounting) {
      return {
        mountpoint: mounting.mountpoint,
        type: mounting.child.type,
        path: mounting.child.path,
        shardFunc: mounting.child.shardFunc
      };
    })
  };
}